import React from "react";
import "../../Styles/certified/contustech.css";

export default function Contustech() {
  return (
    <>
      <div className="contus-certified-details-section">
        <div className="contus-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="contus-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="contus-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="contus-certified-badge"
            />
            <div className="contus-certified-company-names">
              <a href="https://www.contus.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/contustech/contus.png" alt="Contus Tech Logo" className="contus-certified-company-logo" />
              </a>
              <h1 className="contus-certified-full-name">
                Contus Tech Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="contus-certified-details-right">
            <img
              src="/assets/contustech/Image_20251126_131832_628.jpeg"
              alt="Contus Tech Office"
              className="contus-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="contus-certified-description">
          <h2>
            Why Contus Tech Private Limited is a Outstanding Workplaces
          </h2>
          <p>
            CONTUS TECH is a global digital transformation solutions provider, empowering enterprises with cutting-edge technologies in AI, Cloud, and Digital Engineering. 
            With a strong culture of innovation, collaboration, and recognition, CONTUS TECH has built a workplace where people thrive, ideas flourish, and business impact is maximized. 
            Our HR systems and analytics are designed to align talent acquisition with growth goals, ensuring every employee feels valued and empowered.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="contus-certified-info-cards">
          <div className="contus-certified-info-card">
            <div className="contus-certified-info-title">COMPANY SIZE</div>
            <div className="contus-certified-info-value">500+ Employees</div>
          </div>
          <div className="contus-certified-info-card">
            <div className="contus-certified-info-title">INDUSTRY</div>
            <div className="contus-certified-info-value">Information Technology & Digital Transformation</div>
          </div>
          <div className="contus-certified-info-card">
            <div className="contus-certified-info-title">CONNECT</div>
            <div className="contus-certified-info-icons">
              <span className="contus-certified-icon-round">
                <a href="https://www.contus.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="contus-certified-icon-round">
                <a href="https://www.linkedin.com/company/contustech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="contus-certified-icon-round">
                <a href="https://www.facebook.com/Contus.Tech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="contus-certified-icon-round">
                <a href="https://www.instagram.com/contustech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="contus-certified-icon-round">
                <a href="https://x.com/contustech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="contus-certified-info-card">
            <div className="contus-certified-info-title">LOCATION (HQ)</div>
            <div className="contus-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="contus-certified-recognition-section">
          <h2 className="contus-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="contus-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="contus-certified-recognition-image"
            />
          </div>
          <div className="contus-certified-recognition-label">
            Outstanding Workplaces - Gold Certified
          </div>
        </div>
        {/* Life at Contus Section */}
        <div className="contus-certified-life-section">
          <h2 className="contus-certified-life-title">
            Life at Contus Tech Private Limited
          </h2>
          <div className="contus-certified-life-gallery">
            <div className="contus-certified-life-col">
              <img src="/assets/contustech/Image_20251126_131834_232.jpeg" alt="Office 1" className="contus-certified-life-img" />
              <img src="/assets/contustech/Image_20251126_131832_628.jpeg" alt="Meeting 1" className="contus-certified-life-img" />
            </div>
            <div className="contus-certified-life-col contus-certified-life-center">
              <img src="/assets/contustech/Image_20251126_131835_233.jpeg" alt="Main Office" className="contus-certified-life-img contus-certified-life-img-large" />
            </div>
            <div className="contus-certified-life-col">
              <img src="/assets/contustech/Image_20251126_131836_020.jpeg" alt="Office 2" className="contus-certified-life-img" />
              <img src="/assets/contustech/Image_20251126_131833_389.jpeg" alt="Meeting 2" className="contus-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}